import React from 'react';
import { useTranslation } from 'react-i18next';
import Wrapper from '../../HOC/Wrapper';
import assessmentNotAvailable from '../../assets/images/assessment_not_avalible.png';
import styles from './ScheduleContainer.scss';

const ScheduleContainer = () => {
  const { t } = useTranslation('common');
  return (
    <Wrapper>
      <div className={styles.scheduleContainer}>
        <div className={styles.content}>
          <h1 className={styles.title}>{t('schedule.assessment_not_available')}</h1>
          <p className={styles.subtitle}>{t('schedule.access_before_time')}</p>
          <div className={styles.imageContainer}>
            <img
              src={assessmentNotAvailable}
              alt={t('schedule.assessment_not_available_alt')}
              className={styles.image}
            />
            <div className={styles.textOverlay}>
              <p className={styles.overlayText}>{t('schedule.come_back_at_scheduled_time')}</p>
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
};

export default ScheduleContainer;
